<template>
<div>
  <div v-if="show" class="bottom-loading">
    <div></div>
    <div></div>
    <div></div>
  </div>
  <div v-else class="bottom-loading-msg">{{msg}}</div>
</div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    show: {
      type: Boolean,
      default: true
    },
    msg: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
@import url(../mixins.less);

@animateTime: 0.45s;

.bottom-loading{
  .flex();
  .webkitCss(justify-content, center);
  padding: 100 / @ratio 0;
  div{
    .round(4px);
    margin: 0 10 / @ratio;
    background-color: #ddd;
    animation: scale @animateTime infinite alternate;
  }
  div:nth-child(2){
    animation-delay: @animateTime * ( 1 / 3 );
  }
  div:nth-child(3){
    animation-delay: @animateTime * ( 2 / 3 );
  }
}

@keyframes scale {
  from{
    transform: scale(1);
  }
  to{
    transform: scale(1.75);
  }
}

.bottom-loading-msg{
  padding: 100 / @ratio 0;
  font-size:22 / @ratio;
  text-align: center;
  color:rgba(171,171,171,1);
  line-height:26 / @ratio;
}

</style>
